import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppVersionModel } from 'common/models/page-models/App Version Model/app-version-form-model';
import { AppVersionListingModel } from 'common/models/page-models/App Version Model/app-version-grid.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AppVersionGridWidgetService } from 'common/widget/app-version/app-version-grid-widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class AppVersionGridResolver extends GridResolver<AppVersionModel, AppVersionListingModel> {
    constructor(
        protected fs: AppVersionGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }
}